import React from 'react';
import get from 'lodash.get';
import TrcCard from './trcCard/TrcCard';
import SharedScoreCell from '../../../../../../components/cell/shared/ScoreCell';
import {
    getPerformanceLevelAbbr,
    buildTrcObject,
    getFinalTrcResult,
} from '../../../../../../utils/shared/trcUtils';
import { LABEL, TRC_SCORE } from '../../../../../../constants/shared/TrcConstants';
import { MEASURE } from '../../../../../../constants/shared/MeasuresConstants';
import { TITLE } from '../../../../../../constants/shared/CommonConstants';

const { TRC } = MEASURE;

const buildTrcCard = (period, trcResult) => {
    const { isComplete, interp, score, isUnofficial, itemLevelDetails, resultId } = trcResult;
    const finalTrcScore = getFinalTrcResult(itemLevelDetails, resultId);
    const { bookTypeTitle, presumedResult, performanceLevel } = finalTrcScore;
    const scoreObject = {
        bookType: presumedResult ? TRC_SCORE.PS : bookTypeTitle,
        performanceLevel: getPerformanceLevelAbbr(performanceLevel),
        rawValue: score,
    };
    const trcObject = {
        ...buildTrcObject(finalTrcScore),
        interp,
        cardType: LABEL.OBSERVATIONAL,
        scoreObject,
        cell: (
            <SharedScoreCell
                statusForMeasureYearPeriod={{
                    isComplete: true,
                    interp,
                    isUnofficial,
                    score: scoreObject,
                }}
                measure={TRC}
                optionalCellData={{
                    classNames: 'trc-summary-card-cell',
                }}
            />
        ),
        measure: TRC,
        isUnofficial,
    };
    return <TrcCard key={period} period={period} isPaused={!isComplete} result={trcObject} />;
};

const getTrcCard = (period, result, summeryLabel = TITLE.SUMMER_TITLE) => {
    if (get(result, 'measure') === TRC) return buildTrcCard(period, result);
    return <TrcCard key={period} period={period} isEmpty summeryLabel={summeryLabel} />;
};

export default getTrcCard;
